export default __webpack_public_path__ + "static/media/corin.b3a6e9dc.png";